<template>
<nav id="site-navigation" class="has-branding main-navigation nav-align-right sub-menu-right" aria-label="Primary" itemtype="https://schema.org/SiteNavigationElement" itemscope>
  <div class="inside-navigation">
    <div class="navigation-branding">
      <div class="site-logo">
        <a href="/" title="WA GB" rel="home">
          <img class="header-image is-logo-image" alt="WA GB" :src="siteLogo" title="WA GB">
        </a>
      </div>
      <p class="main-title" itemprop="headline">
        <a href="/" rel="home">WA GB APK</a>
      </p>
    </div>

    <ul id="menu-primary-menu" class="menu sf-menu mobile-menu-page" v-show="isMenuClicked">
      <li v-for="link in navLinks" :key="link.label" class="menu-item">
        <a :href="link.href" :class="{ 'download-btn': link.href === '/download-wa-gb/' }">
          {{ link.label }}
        </a>
      </li>
    </ul>

    <div id="primary-menu" class="main-nav">
      <div class="mobile-menu">
        <button class="menu-toggle" type="button" :aria-expanded="isMenuClicked" aria-label="Menu" @click="isMenuClicked = !isMenuClicked">
          <img src="@/assets/menu.svg" alt="Buka menu" v-if="!isMenuClicked">
          <img src="@/assets/xmark-black.svg" alt="Tutup menu" v-else>
        </button>
      </div>

      <ul id="menu-primary-menu" class="menu sf-menu desktop-menu">
        <li v-for="link in navLinks" :key="link.label" class="menu-item" :class="{ 'header-download': link.href === '/download-wa-gb/' }">
          <a :href="link.href" :class="{ 'download-btn': link.href === '/download-wa-gb/' }">
            {{ link.label }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>
</template>

<script>
import { navLinks, siteLogo } from '@/documents/siteContent.js'

export default {
  props: {
    selectedLanguage: {
      type: String,
      required: true
    },
    page: {
      type: String,
      required: true
    },
    gotodownload: {
      type: Function
    },
    apk: {
      type: [Object, String]
    }
  },
  data() {
    return {
      isMenuClicked: false,
      navLinks,
      siteLogo
    }
  }
}
</script>

<style lang="scss" scoped>
#site-navigation {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);

  .inside-navigation {
    width: 88%;
    margin: 0 auto;
    z-index: 9999;
    position: relative;
  }
}

.main-nav {
  .mobile-menu {
    display: none;
  }

  .menu {
    display: flex;
    align-items: center;
    gap: 2px;
    list-style-type: none !important;
    margin: 0 !important;

    li a {
      font-weight: 600 !important;
      padding-inline: 12px;
    }
  }
}

@media screen and (max-width: 768px) {
  #site-navigation {
    .inside-navigation {
      width: calc(100% - 32px);
      min-height: 64px;
    }
  }

  .inside-navigation {
    .mobile-menu-page {
      position: absolute;
      top: 100%;
      width: 100%;
      z-index: 1001;
      margin: 0 !important;
      border-top: 1px solid #eef0f0;

      .menu-item {
        padding: 0;
        margin-bottom: 0 !important;
        background: #fff;

        a {
          display: block;
          padding: 14px 0;
          color: #121212;
          font-size: 15px;
          text-align: center;
        }
      }
    }
  }

  .main-nav {
    flex: 1;
    margin-right: 0;

    .desktop-menu {
      display: none;
    }

    .mobile-menu {
      display: flex;
      justify-content: flex-end;
      position: relative;

      .menu-toggle {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 44px;
        height: 44px;
        padding: 12px;
        border: 0;
        background: transparent;
        margin-bottom: 0;
        cursor: pointer;

        img {
          width: 23px;
          height: 23px;
        }
      }
    }
  }
}
</style>
